module.exports = __webpack_public_path__ + "img/sto_bg_loc@2x.e31e7166.png";